import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";
import HomeBanner3 from "../ones/HomeBanner3";
import HomeBanner4 from "../ones/HomeBanner4";
import HomeBanner2 from "../ones/HomeBanner2";
import ServicesBanner1 from "../ones/ServicesBanner1";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<>
				<HomeBanner1/>
				<HomeBanner2/>
				<HomeBanner3/>
				<ServicesBanner1/>
				<HomeBanner4/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}
